import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import mixin from './mixin.js';
import { isEmpty } from '@/utils';
import { shopConfig, getLog, getMainTemplate, getPictureByKey } from './api/index';
import { getCategory } from '@/views/platformConfig/api';
import { watchCompanyName } from '@/views/cardSystem/customer/api';
export default {
  name: 'styleConfig',
  mixins: [mixin],
  props: {
    propInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      fieldsToCheck: [{
        key: 'short_name',
        type: '2',
        label: '查看'
      }, {
        key: 'company_name',
        type: '3',
        label: '查看'
      }],
      loadedHomeStyle: '',
      originFormData: null,
      info: {},
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      menuList: [],
      childrenMenuList: [],
      formData: {
        home_index_name: '',
        home_style: '',
        main_style_id: '',
        home_show_mode: '1',
        login_type: '1',
        login_type_c: '1',
        home_data_rule: '1',
        customer_home_banner_type: '0',
        customer_home_banner: {
          width: 750,
          height: 280,
          value: [{
            imageurl: '',
            link_type: '1',
            link_value: '',
            sort: '1'
          }]
        }
      },
      rules: {
        home_style: [{
          required: true,
          message: '请选择首页模板',
          trigger: 'change'
        }],
        main_style_id: [{
          required: true,
          message: '请选择继承的模板',
          trigger: 'change'
        }],
        home_show_mode: [{
          required: true,
          message: '请选择商城首页展示逻辑',
          trigger: 'change'
        }],
        login_type: [{
          required: true,
          message: '请选择商城登录方式',
          trigger: 'change'
        }],
        login_type_c: [{
          required: true,
          message: '请选择C端商城默认登录页',
          trigger: 'change'
        }],
        home_data_rule: [{
          required: true,
          message: '请选择页面展示方式',
          trigger: 'change'
        }],
        customer_home_banner_type: [{
          required: true,
          message: '请选择商城首页Banner图',
          trigger: 'change'
        }]
      },
      dialogShow: false,
      dialogForm: {
        operate_time: [],
        operator_id: '',
        page: 1,
        page_size: 20
      },
      totalCount: 0,
      logList: [],
      mainTempList: [],
      showPictureLibrary: false,
      pictureList: [],
      updateIndex: 0,
      depot: {}
    };
  },
  methods: {
    getChangedFields: function getChangedFields(newData, oldData) {
      if (!oldData) {
        return [];
      }
      return Object.keys(newData).filter(function (key) {
        return JSON.stringify(newData[key]) !== JSON.stringify(oldData[key]);
      });
    },
    watchCustomerName: function watchCustomerName(type) {
      var _this = this;
      var params = {
        id: this.info.customer_id
      };
      watchCompanyName(params).then(function (res) {
        if (type === '1') {
          _this.info.customer_name = res.data.company_name;
        } else if (type === '2') {
          _this.info.short_name = res.data.company_name;
        } else if (type === '3') {
          _this.info.company_name = res.data.company_name;
        }
      });
    },
    shouldShowButton: function shouldShowButton(fieldValue) {
      return fieldValue && fieldValue.includes('*');
    },
    selectPicture: function selectPicture(index) {
      if (!this.canEditBanner) {
        this.$message.warning('无此操作权限');
        return;
      }
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.formData.customer_home_banner.value[this.updateIndex]['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    getPicture: function getPicture() {
      var _this2 = this;
      getPictureByKey({
        key: 'banner_new'
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this2.pictureList = picture[1] || [];
        _this2.depot = depot; // 分类枚举
      });
    },
    changeMainTemp: function changeMainTemp(item) {
      if (this.isSaleEditBannerMode) {
        this.$message.warning('无此操作权限');
        return;
      }
      if (this.disabled) {
        return;
      }
      this.formData.main_style_id = item.id;
    },
    getMainTempList: function getMainTempList(data) {
      var _this3 = this;
      var channel_id = data.channel_id,
        _data$main_style_id = data.main_style_id,
        main_style_id = _data$main_style_id === void 0 ? '' : _data$main_style_id;
      getMainTemplate({
        channel_id: channel_id,
        main_style_id: main_style_id
      }).then(function (res) {
        if (!Number(main_style_id)) {
          var mainTemp = res.data.find(function (i) {
            return i.is_main == 1;
          });
          _this3.formData.main_style_id = mainTemp.id;
        }
        _this3.mainTempList = res.data.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            current: i.id + '' === _this3.formData.main_style_id + ''
          });
        });
      });
    },
    changeHomeStyle: function changeHomeStyle(val) {
      if (['shop', 'work'].includes(val)) {
        this.formData.home_show_mode = '1';
        this.formData.home_data_rule = '2';
      }
    },
    resetForm: function resetForm() {
      this.handleClose();
      this.getLogData();
    },
    handleClose: function handleClose() {
      this.$refs.dialogForm.resetFields();
    },
    // 获取操作日志列表
    getLogData: function getLogData(page) {
      var _this4 = this;
      this.dialogForm.page = typeof page === 'number' ? page : 1;
      var _this$info = this.info,
        module = _this$info.module,
        _this$info$channel_id = _this$info.channel_id,
        channel_id = _this$info$channel_id === void 0 ? '0' : _this$info$channel_id,
        _this$info$customer_i = _this$info.customer_id,
        customer_id = _this$info$customer_i === void 0 ? '0' : _this$info$customer_i;
      var _ref = this.dialogForm.operate_time || [],
        _ref2 = _slicedToArray(_ref, 2),
        _ref2$ = _ref2[0],
        start_operate_time = _ref2$ === void 0 ? '' : _ref2$,
        _ref2$2 = _ref2[1],
        end_operate_time = _ref2$2 === void 0 ? '' : _ref2$2;
      start_operate_time = start_operate_time === '' ? start_operate_time : "".concat(start_operate_time, " 00:00:00");
      end_operate_time = end_operate_time === '' ? end_operate_time : "".concat(end_operate_time, " 23:59:59");
      getLog(_objectSpread({
        operate_type: 0,
        // 固定传参
        category_id: 0,
        // 固定传参
        channel_id: channel_id,
        customer_id: customer_id,
        start_operate_time: start_operate_time,
        end_operate_time: end_operate_time
      }, this.dialogForm), module).then(function (res) {
        var _res$data2 = res.data,
          data = _res$data2 === void 0 ? {} : _res$data2,
          pages = res.pages;
        _this4.logList = data.list;
        _this4.totalCount = pages.totalCount;
        _this4.dialogShow = true;
      });
    },
    // 获取菜单列表
    getMenuList: function getMenuList() {
      var _this5 = this;
      /**
       * status === 0 正常状态
       * 菜单状态为隐藏或删除时 添加disabled属性
       * falg : 一级状态为删除或隐藏时,子级同步全部置灰
       */
      var _addDisableProperty = function addDisableProperty(obj, flag) {
        var id = obj.id.split(':')[1] || '';
        obj.disabled = flag || obj.status !== 0 && obj.status !== 1;
        obj.show_name = "".concat(obj.name).concat(id ? "ID".concat(id) : '').concat(obj.alias_name ? "\uFF08".concat(obj.alias_name, "\uFF09") : '');
        if (Array.isArray(obj.childrens)) {
          obj.childrens = obj.childrens.map(function (child) {
            return _addDisableProperty(child, obj.disabled);
          });
        }
        return obj;
      };
      getCategory({}, 'mall').then(function (res) {
        _this5.menuList = res.data.map(function (item) {
          return _addDisableProperty(item);
        });
      });
    },
    updateHeight: function updateHeight() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var bannerList, imgInfoArr, _iterator, _step, item, _yield$_this6$getImgW, height, width, maxItem, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              bannerList = _this6.formData.customer_home_banner.value;
              if (!bannerList.length) {
                _context.n = 9;
                break;
              }
              imgInfoArr = [];
              _iterator = _createForOfIteratorHelper(bannerList);
              _context.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context.n = 5;
                break;
              }
              item = _step.value;
              _context.n = 3;
              return _this6.getImgWH(item.imageurl);
            case 3:
              _yield$_this6$getImgW = _context.v;
              height = _yield$_this6$getImgW.height;
              width = _yield$_this6$getImgW.width;
              imgInfoArr.push({
                height: height,
                width: width
              });
            case 4:
              _context.n = 2;
              break;
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              _iterator.e(_t);
            case 7:
              _context.p = 7;
              _iterator.f();
              return _context.f(7);
            case 8:
              maxItem = imgInfoArr.reduce(function (prev, current) {
                return prev['height'] > current['height'] ? prev : current;
              });
              _this6.formData.customer_home_banner.height = maxItem.height;
              _this6.formData.customer_home_banner.width = maxItem.width;
            case 9:
              return _context.a(2);
          }
        }, _callee, null, [[1, 6, 7, 8]]);
      }))();
    },
    getImgWH: function getImgWH(img_url) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.src = img_url;
        img.onload = function () {
          resolve({
            width: img.width,
            height: img.height
          });
        };
      });
    },
    onDelete: function onDelete(index) {
      var _this7 = this;
      if (!this.canEditBanner) {
        this.$message.warning('无此操作权限');
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this7.formData.customer_home_banner.value.splice(index, 1);
        _this7.updateHeight();
      }).catch(function () {});
    },
    addUpload: function addUpload() {
      if (!this.canEditBanner) {
        this.$message.warning('无此操作权限');
        return;
      }
      // 后端可能返回不含 value 数组的 banner 配置，先兜底初始化
      if (!Array.isArray(this.formData.customer_home_banner.value)) {
        this.$set(this.formData.customer_home_banner, 'value', []);
      }
      this.formData.customer_home_banner.value.push({
        imageurl: '',
        link_type: '1',
        link_value: '',
        sort: ''
      });
    },
    radioChange: function radioChange(val, item) {
      if (!this.canEditBanner) {
        this.$message.warning('无此操作权限');
        return;
      }
      item.link_value = '';
    },
    onUpload: function onUpload(index) {
      if (!this.canEditBanner) {
        this.$message.warning('无此操作权限');
        return;
      }
      this.$refs.uploadBanner[index].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
      this.updateHeight();
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 保存配置信息
    saveConfig: function saveConfig() {
      var _this8 = this;
      if (this.isSaleEditBannerMode) {
        var changedFields = this.getChangedFields(this.formData, this.originFormData);
        var nonBannerChanged = changedFields.filter(function (key) {
          return !['customer_home_banner_type', 'customer_home_banner'].includes(key);
        });
        if (nonBannerChanged.length > 0) {
          this.$message.warning('无此操作权限');
          return;
        }
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var _this8$info = _this8.info,
            customer_id = _this8$info.customer_id,
            channel_id = _this8$info.channel_id,
            module = _this8$info.module;
          var formData = _this8.isSaleEditBannerMode ? _objectSpread(_objectSpread({}, _this8.originFormData || {}), {}, {
            customer_home_banner_type: _this8.formData.customer_home_banner_type,
            customer_home_banner: _this8.formData.customer_home_banner
          }) : _this8.formData;
          shopConfig(module, _objectSpread(_objectSpread(_objectSpread({}, formData), ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
            customer_id: customer_id
          } : {}), module === 'admin' ? {
            channel_id: channel_id
          } : {}), 'post').then(function (_) {
            _this8.getConfig();
            _this8.$message({
              message: '操作成功！',
              type: 'success'
            });
          });
        }
      });
    },
    changeLoginType: function changeLoginType(v) {
      this.formData.login_type_c = v;
      this.formData.home_data_rule = v;
    },
    // 获取配置信息
    getConfig: function getConfig() {
      var _this9 = this;
      var _this$info2 = this.info,
        customer_id = _this$info2.customer_id,
        channel_id = _this$info2.channel_id,
        module = _this$info2.module;
      // 获取商城配置
      shopConfig(module, _objectSpread(_objectSpread({}, ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
        customer_id: customer_id
      } : {}), module === 'admin' ? {
        channel_id: channel_id
      } : {})).then(function (res) {
        var data = res.data;
        if (isEmpty(data)) {
          return;
        }
        _this9.loadedHomeStyle = data.home_style || '';
        Object.keys(_this9.formData).forEach(function (k) {
          _this9.formData[k] = isEmpty(data[k]) ? _this9.formData[k] : data[k];
        });
        _this9.originFormData = JSON.parse(JSON.stringify(_this9.formData));
        if (['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) && data.channel_home_style === 'user_defined') {
          _this9.getMainTempList(data);
        }
        _this9.$nextTick(function () {
          _this9.$refs.form.clearValidate();
        });
      });
    }
  },
  created: function created() {
    var _this0 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!isEmpty(_this0.propInfo)) {
              _context2.n = 2;
              break;
            }
            _context2.n = 1;
            return _this0.getQueryInfo();
          case 1:
            data = _context2.v;
            // 获取路由信息
            _this0.info = data;
            _context2.n = 3;
            break;
          case 2:
            _this0.info = _this0.propInfo;
          case 3:
            if (_this0.isCustomer) {
              _this0.formData.home_style = 'channel_style';
              _this0.getMenuList();
              _this0.getChildrenMenu(); // 获取多个右侧配置项所需的子页面菜单列表
              _this0.getPicture();
            } else {
              _this0.formData.home_style = 'shop';
            }
            _this0.getConfig();
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  },
  computed: {
    canEditBanner: function canEditBanner() {
      if (!this.isSaleEditBannerMode) {
        return true;
      }
      return this.loadedHomeStyle === 'channel_style_or_defined';
    },
    showSaveButton: function showSaveButton() {
      if (!this.isSaleEditBannerMode) {
        return true;
      }
      return this.loadedHomeStyle === 'channel_style_or_defined' && this.formData.home_style === 'channel_style_or_defined';
    },
    isSaleEditBannerMode: function isSaleEditBannerMode() {
      return this.$route.query.saleEdit == 1 && this.$hasBtnRoles('/orders/customer/home-renovation');
    },
    isCustomer: function isCustomer() {
      return ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(this.info.module);
    },
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    }
  }
};